import { Args, AxiosPagePromise, BaseService } from './BaseService';
import { resources } from '../resources';
import { AxiosPromise, type RawAxiosRequestConfig } from 'axios';
import { InvitationTypeVisitRequest } from '../models/request/InvitationTypeVisitRequest';
import { SupplierEmployeeDto } from '../models/suppliers/SupplierEmployeeDto';
import { Page } from '../models/common/Page';
import { VisitationDto } from '../models/visitations/VisitationDto';
import { BaseSearchParams } from '../params/BaseSearchParams';

export class InvitationVisitService extends BaseService {
  public createInvitationTypeVisit(body: InvitationTypeVisitRequest, args?: Args): AxiosPromise<SupplierEmployeeDto> {
    return this.post<SupplierEmployeeDto>(resources.createInvitationTypeVisit, body, args);
  }
  public queryInvitationTypeVisit(params?: BaseSearchParams, options: RawAxiosRequestConfig = {}): AxiosPagePromise<VisitationDto> {
    return this.get<Page<VisitationDto>>(resources.queryInvitationTypeVisit, params, options);
  }
}
